import MonthlyHistogramContainerMobile from '../../../../components/containers/MonthlyHistogramContainerMobile';
import preloadCustomProps from '../../../utils/preloads/preloadHistogramProps';
import deepmerge from '../../../utils/deepmerge';

const cmpConfig = {
  name: 'monthly-histogram--mobile',
  moduleId: 'em-cmp-lib-airmodules',
  staticAssetsHost: 'https://em-frontend-assets.airtrfx.com',
  version: 'NO_NEEDED',
  containerConfig: {
    settings: {
      instance: MonthlyHistogramContainerMobile
    }
  },
  hooks: {
    params: {},
    preloadCustomProps
  }
};

const finalConfig = deepmerge(cmpConfig, {});

export default finalConfig;
